/** Client HTTP minimaliste — toutes les requêtes vers /api passent ici. */

/** Erreur HTTP enrichie : on garde le `status` et le corps JSON pour que les
 *  appelants puissent lire des champs métier (ex. `conflicts`, `errors`). */
export class ApiError extends Error {
  constructor(message: string, public status: number, public body: Record<string, unknown>) {
    super(message);
    this.name = "ApiError";
  }
}

async function request<T>(
  method: string,
  url: string,
  body?: unknown,
): Promise<T> {
  const init: RequestInit = {
    method,
    credentials: "include",
    headers: body !== undefined ? { "Content-Type": "application/json" } : {},
  };
  if (body !== undefined) init.body = JSON.stringify(body);

  const res = await fetch(url, init);
  if (!res.ok) {
    const err = await res.json().catch(() => ({ error: res.statusText })) as Record<string, unknown>;
    const msg = (err.error as string) ?? (err.description as string) ?? res.statusText;
    throw new ApiError(msg, res.status, err);
  }
  return res.json() as Promise<T>;
}

export const api = {
  get: <T>(url: string) => request<T>("GET", url),
  post: <T>(url: string, body?: unknown) => request<T>("POST", url, body),
  put: <T>(url: string, body?: unknown) => request<T>("PUT", url, body),
  patch: <T>(url: string, body?: unknown) => request<T>("PATCH", url, body),
  delete: <T>(url: string) => request<T>("DELETE", url),

  /** Upload multipart (pièces jointes) */
  upload: async <T>(url: string, file: File): Promise<T> => {
    const form = new FormData();
    form.append("file", file);
    const res = await fetch(url, {
      method: "POST",
      credentials: "include",
      body: form,
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({ error: res.statusText }));
      throw new Error(err.error ?? err.description ?? res.statusText);
    }
    return res.json() as Promise<T>;
  },
};
